"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertError = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const alertError = (error, defaultMessage, params = {}) => {
    let message = defaultMessage;
    const errorMessage = error instanceof Error ? error.message : error;
    if (errorMessage == legacy_enums_1.RejectionType.CanceledOrder) {
        message = "Assignation not possible - you have tried to assign a driver to a cancelled order";
        message += (0, utils_1.isNotUndefinedOrNull)(params.orderId) ? ` ${params.orderId}` : "";
    }
    // eslint-disable-next-line no-alert
    alert(message);
};
exports.alertError = alertError;
//# sourceMappingURL=errorHelper.js.map